import { BreadcrumbNav } from "@/components/ui/breadcrumb-nav"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Mail, MessageSquare, Phone } from "lucide-react"
import { Button } from "@/components/ui/button"

export const SupportPage = () => {
    const handleEmailSupport = () => {
        window.location.href = "mailto:support@uavity.com"
    }

    return (
        <main className="min-h-screen bg-background">
            <div className="container mx-auto px-6 py-8 max-w-4xl">
                <BreadcrumbNav
                    items={[
                        { label: "Home", href: "/" },
                        { label: "Support", href: "/support" },
                    ]}
                    className="mb-6"
                />
                
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-2xl font-semibold mb-1">Support</h1>
                    <p className="text-muted-foreground">
                        Need help? We are here to assist you directly.
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <Mail className="h-5 w-5" />
                                Email Support
                            </CardTitle>
                            <CardDescription>
                                The best way to reach us for detailed inquiries.
                            </CardDescription>
                        </CardHeader>
                        <CardContent>
                            <p className="mb-4 text-sm text-muted-foreground">
                                We aim to respond to all support emails within 24 hours. 
                                Please describe your issue in detail so we can help you faster.
                            </p>
                            <Button onClick={handleEmailSupport} className="w-full">
                                Email support@uavity.com
                            </Button>
                        </CardContent>
                    </Card>

                    <Card>
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <MessageSquare className="h-5 w-5" />
                                Feedback
                            </CardTitle>
                            <CardDescription>
                                Have a suggestion or found a bug?
                            </CardDescription>
                        </CardHeader>
                        <CardContent>
                            <p className="mb-4 text-sm text-muted-foreground">
                                We value your feedback and are constantly working to improve our platform.
                                Let us know how we can make your experience better.
                            </p>
                             <Button variant="outline" onClick={handleEmailSupport} className="w-full">
                                Send Feedback
                            </Button>
                        </CardContent>
                    </Card>
                </div>

                <div className="mt-8">
                     <Card>
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <Phone className="h-5 w-5" />
                                Urgent Inquiries
                            </CardTitle>
                            <CardDescription>
                                For critical issues affecting your operations.
                            </CardDescription>
                        </CardHeader>
                        <CardContent>
                            <p className="text-sm text-muted-foreground">
                                If you are experiencing a critical system failure, please email us with the subject line "URGENT" 
                                and we will prioritize your request.
                            </p>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </main>
    )
}

